import script from "./BirthdayFlower.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthdayFlower.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__